import {
    GET_CURATION_SUCCESS, GET_CURATION_LOADING, GET_CURATION_ERROR,
    PATCH_CURATION_SUCCESS, PATCH_CURATION_LOADING, PATCH_CURATION_ERROR
} from "../Type";
import * as Authservices from "../../Services/services";

export const getCuration = (curationType) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: GET_CURATION_LOADING, data: true });
        Authservices.getCuration(curationType)
            .then((res) => {
                if (res?.status >= 200 && res?.status < 300) {
                    dispatch({ type: GET_CURATION_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: GET_CURATION_ERROR, data: err?.response?.data?.responseMessage });
                // Status travels with the body so the screen can tell a 404 (route or
                // curation_type not deployed) and a 409 (stale config id) apart.
                reject({ ...(err?.response?.data || {}), status: err?.response?.status });
            });
    });
};

export const patchCuration = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: PATCH_CURATION_LOADING, data: true });
        Authservices.patchCuration(data)
            .then((res) => {
                if (res?.status >= 200 && res?.status < 300) {
                    dispatch({ type: PATCH_CURATION_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: PATCH_CURATION_ERROR, data: err?.response?.data?.responseMessage });
                reject({ ...(err?.response?.data || {}), status: err?.response?.status });
            });
    });
};
